import * as React from 'react';
import { AccVideoDetailResultVO } from '@domain/vo/acca/v1/test/result/apply/AccVideoResultVO';
import classNames from 'classnames/bind';
import styles from './v4Question.module.scss';

const cx = classNames.bind(styles);

interface V4QuestionProps {
  videoDetailTab: AccVideoDetailResultVO | null;
}

const V4Question = ({ videoDetailTab }: V4QuestionProps) => {
  if (!videoDetailTab) return null;
  const { question } = videoDetailTab;

  return (
    <div className={cx('questionArea')}>
      <span className={cx('mark')}>질문</span>
      <div className={cx('questionWrap')}>
        <em className={cx('question')}>{question}</em>
        <ul className={cx('noticeList')}>
          <li className={cx('listItem')}>영상 확인은 결과표 유효기간 내에 가능해요.</li>
        </ul>
      </div>
    </div>
  );
};

export default V4Question;
